/* Fit the two authored headline lines to their column; no storefront controls. */
(() => {
  function fitHeadings(root = document) {
    root.querySelectorAll('.known-home-product-title').forEach(heading => {
      if (heading.dataset.fitReady) return;
      heading.dataset.fitReady = 'true';
      function fit() {
        const size = parseFloat(getComputedStyle(heading).fontSize);
        const widths = [...heading.querySelectorAll('span')].map(line => {
          const range = document.createRange();
          range.selectNodeContents(line);
          return range.getBoundingClientRect().width;
        });
        const widest = Math.max(...widths);
        if (widest > 0 && heading.clientWidth > 2) {
          heading.style.fontSize = Math.max(1, Math.floor((heading.clientWidth - 2) * size / widest)) + 'px';
        }
      }
      let width = 0;
      const observer = new ResizeObserver(entries => {
        const next = entries[0].contentRect.width;
        if (next !== width) { width = next; fit(); }
        if (!heading.isConnected) observer.disconnect();
      });
      observer.observe(heading);
      fit();
      document.fonts.ready.then(fit);
    });
  }
  fitHeadings();
  document.addEventListener('shopify:section:load', event => fitHeadings(event.target));
})();
